import { useEffect } from "react";
import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Reschedule from "@/pages/Reschedule";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";
import { AccountAuthProvider } from "@/context/AccountAuth";

function AppRouter() {
  const location = useLocation();
  // Process OAuth return FIRST (session_id lives in the URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/reschedule" element={<Reschedule />} />
      <Route path="/account" element={<Account />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = "Fairy Yasha — Psychic Reader, Medium & Energy Healer | Charlotte, NC";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, anchors: true }}>
      <div className="App" data-testid="landing-page">
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#1F130E",
              border: "1px solid rgba(201,162,75,0.35)",
              color: "#EFE3CC",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <BrowserRouter>
          <AccountAuthProvider>
            <AppRouter />
          </AccountAuthProvider>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
